import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Chart from "react-apexcharts";
import axios from "axios";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import {
  getTradesData,
  getTradesFromDatabase,
  setReportsLoading,
  setReportsLoadingFinished,
  setTradesLoading,
  setTradesLoadingFinished,
} from "../../actions/tradesActions";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";

import Spinner from "../common/Spinner";
import { faIR } from "@mui/x-data-grid";
import { type } from "@testing-library/user-event/dist/type";
import { LineWeight } from "@mui/icons-material";
import { GET_TRADES } from "../../actions/types";
import PopupPortal from "./PopupPortal";
import { abrirPopup } from "./popupController";
import ApexCharts from "apexcharts";
import { useUI } from "../context/UIContext";

const formato = (v) =>
  v ? `COP ${Number(v).toLocaleString('es-CO')}` : 'COP 0';

function buildDetalleHTML({ w, series, dataPointIndex, detalleGastos }) {
  let html = `<div class="tooltip-gastos" style="padding:10px 12px; min-width:280px">`;

  const mes = w.globals.labels?.[dataPointIndex] ?? `Mes ${dataPointIndex + 1}`;
  //html += `<div style="font-weight:600; margin-bottom:8px">${mes}</div>`;

  const detalleMes = detalleGastos?.[dataPointIndex] || {};

  const detallesHTML = Object.entries(detalleMes)
    .filter(([k, v]) => Number(v) > 0)
    .map(([key, value]) => `
      <div style="display:flex; justify-content:space-between; gap:12px">
        <span>${key.replaceAll('_', ' ')}</span>
        <b>${formato(value)}</b>
      </div>
    `)
    .join('');

  html += detallesHTML || `<i style="opacity:.7"></i>`;
  html += `</div>`;

  return html;
}

function renderMiniChart(series, dataPointIndex, detalle) {
  const el = document.querySelector("#miniChart");
  if (!el) return;

  const detalleMes = detalle?.[dataPointIndex] || {};

  // 👇 AQUÍ va tu bloque (Top 8 subcuentas)
  const entries = Object.entries(detalleMes)
    .map(([k, v]) => [k, Number(v) || 0])
    .filter(([, v]) => v > 0)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);   // ⬅️ top 8

  const categorias = entries.map(([k]) => k.replaceAll('_', ' '));
  const data = entries.map(([, v]) => v);

  const options = {
  chart: {
    type: "bar",
    height: 360,
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: "60%",
      borderRadius: 6
    }
  },
  series: [{ name: "Gastos", data }],
  xaxis: {
    labels: {
      show: false   // ⬅️ ocultamos labels del eje para que no se monten
    }
  },
  yaxis: {
    labels: {
      show: false   // ⬅️ ocultamos categorías en el eje
    }
  },
  tooltip: {
    fixed: {
    enabled: true,
    position: "center",   // 👈 centro del chart
    offsetX: 0,
    offsetY: 0
  },
    shared: false,
    intersect: true,
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      const categoria = categorias[dataPointIndex]; // nombre de subcuenta
      const valor = series[seriesIndex][dataPointIndex];
      return `
        <div style="padding:8px 10px; min-width:200px">
          <div style="font-weight:600; margin-bottom:4px">${categoria}</div>
          <div>Valor: <b>COP ${Number(valor).toLocaleString('es-CO')}</b></div>
        </div>
      `;
    }
  }
};



  new ApexCharts(el, options).render();
}




function arrayFilter(array, max) {
  let newArray = [];
  for (let i = 0; i < array.length - 2; i += array.length / max) {
    newArray.push(array[parseInt(i)]);
  }
  newArray.push(array[array.length - 1]);
  return newArray;
}

export default function ReportsOverviewInventoryOdo({ selected, filters }) {
  const expired = useSelector((store) => store.auth.user.expired);
  const userId = useSelector((store) => store.auth.user.public_id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const loading_reports = useSelector((store) => store.trades.loading_reports);


  useEffect(() => {
    if (expired) {
      navigate("/profile/account_plan");
      enqueueSnackbar("Your Account is Expired", {
        variant: "error",
      });
    }
  }, [expired, navigate, enqueueSnackbar]);

  const [EstadoData, setEstadoData] = useState(true);
  const [EstadoAnual, setEstadoAnual] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [totalVentas, setTotalVentas] = useState();
  const [totalCostos, setTotalCostos] = useState();
  const [totalGastos, setTotalGastos] = useState();
  const [totalEbitda, setTotalEbitda] = useState();
  const [textoAño, setTextoAño] = useState('');
  const [ventasArea, setventasArea] = useState();
  const [costosArea, setcostosArea] = useState();
  const [gastosArea, setgastosArea] = useState();
  const [ChartDataProductos,setChartDataProductos]= useState();
  const [ChartDataAsesores,setChartDataAsesores]= useState();
  const [RegionVentas,setRegionVentas]= useState({});
  const [cobrosArea, setcobrosArea] = useState();
  const [pagosArea, setpagosArea] = useState();
  const [inventarioArea, setinventarioArea] = useState();
  const [liquidezArea, setliquidezArea] = useState();
  const [pruebaacida, setpruebaacidaArea] = useState();
  const [capitaltrabajo, setcapitaltrabajoArea] = useState();
  const [endeudamientoArea, setendeudamientoArea] = useState();
  const [apalancamientoArea, setapalancamientoArea] = useState();
  const [Insights,setisights]= useState({});
  const [options1, setoptions1] = useState({})
  const [series1, setseries1] = useState({})
  const [currency, setCurrency] = useState("COP");
  
  const location = useLocation();
  
  const decisiones = [
  {
    titulo: "Hacer promociones",
    tipo: "no_rotation",
    color: "#FF4560",
    descripcion: "Productos sin rotación reciente"
  },
  {
    titulo: "Reabastecer urgente",
    tipo: "stock_risk",
    color: "#FEB019",
    descripcion: "Stock a punto de agotarse"
  },
  {
    titulo: "Reabastecer inmediatamente",
    tipo: "sold_out",
    color: "#FF4560",
    descripcion: "Stock agotado"
  },
  {
    titulo: "Detener compras",
    tipo: "overstock",
    color: "#00E396",
    descripcion: "Exceso de inventario"
  }
];
  const { tabValue } = useUI();

  const trades = useSelector((store) => store.trades);
  const locales = {
  COP: "es-CO",
  USD: "en-US",
  EUR: "es-ES",
  MXN: "es-MX",
  CLP: "es-CL",
  PEN: "es-PE"
  };

  const toMoney = value => {
    const money = Number(value);
    if (isNaN(money)) {
      return value;
    }
    const locale = locales[currency] || "es-CO";
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0  }).format(Math.floor(money))
  }

 

 
  const [optionColumnChart, setOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [ejemploTortaChart1, setEjemploTortaChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  })

  
  
  const [ejemploChart1, setejemploChart] = useState({
    name: "",
    color: "#00E396",
    data: [],
  })
  
  const [ejemploOptionChart1, setEjemploOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });


 


  const [ejemploChart2, setejemploChart2] = useState({
    name: "",
    color: "#00E396",
    data: [],
  
  })
  
  const [ejemploOptionChart2, setEjemploOptionColumnChart2] = useState({
  series:[],
  options:{
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: { categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
  }
  });



  const [ejemploOptionChart4, setEjemploOptionColumnChart4] = useState({
    series:[],
    options:{
      chart: {
        type: "bar",
        stacked: true,
        height: 350,
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -100,
                to: -46,
                color: "#F15B46",
              },
              {
                from: -45,
                to: 0,
                color: "#FEB019",
              },
            ],
          },       
          horizontal: false,
          borderRadius: 0,
          borderRadiusApplication: 'around',
          borderRadiusWhenStacked: 'last',
          columnWidth: '70%',
          barHeight: '200%',
          distributed: false,
          rangeBarOverlap: true,
          rangeBarGroupRows: false,
          hideZeroBarsWhenGrouped: false,
          isDumbbell: false,
          dumbbellColors: undefined,
          isFunnel: false,
          isFunnel3d: true
        },
      },
      dataLabels: {
        enabled: false,
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -50,
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                }
      },
      yaxis: {
        labels: {
          formatter: function (y) {
            return y.toFixed(2);
          },
        },
      },
      xaxis: { categories: ['eseero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
    }
    });



    const [ejemplolinea, setejemplolinea] = useState({
      
       options : {
        series: [
      ],
        chart: {
        height: 350,
        stacked: true,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: [1, 1, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos vs costos',
        //offsetX: 110
      },
      xaxis: {
        categories: [2021, 2022, 2023, 2024],
      },
      yaxis: [
        {
          min: 0,
          max: 800000000,
          seriesName: 'Income',
          title: {
            text: '',
          },
        },
        {
          min: 0,
          max: 800000000,
          seriesName: 'Cashflow',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
       
      ],
      tooltip: {
        fixed: {
          enabled: true,
          position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60
        },
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "$";
            }
            return y;
            
          }},
          {
            formatter: function (y) {
              if(typeof y !== "undefined") {
                return  y.toFixed(4) + "%";
              }
              return y;
              
            }
        }]
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40
      }
      }

     
    
    
      });




      const [ejemplolinea2, setejemplolinea2] = useState({
      
        options : {
         series: [
       ],
         chart: {
         height: 350,
         stacked: true,
         type: 'line',
         toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
       },
      },
       dataLabels: {
         enabled: false
       },
       stroke: {
         curve: 'smooth',
         width: [1, 1, 1,4]
       },
       plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: false,
              offsetX: 0,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
       grid: {
         show:false,
         borderColor: '#e7e7e7',
         row: {
           colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
           opacity: 0.5
         },
       },
       markers: {
        size: 1
      },
       title: {
         text: 'Gastos admon y ventas',
         //offsetX: 110
       },
       xaxis: {
         categories: [2021, 2022, 2023, 2024],
       },
       yaxis: [
         {
          min: 0,
          max: 800000000,
           seriesName: 'ventas',
           title: {
             text: '',
           },
         },
         {
          min: 0,
          max: 800000000,
           seriesName: 'Gastos administracion',
           labels: {
             show: false,
           },
           opposite: false,
           axisTicks: {
             show: false,
           },
         },

         {
          min: 0,
          max: 800000000,
          seriesName: 'Gastos ventas',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
      
        
       ],
       tooltip: {
         fixed: {
           enabled: true,
           position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
           offsetY: 30,
           offsetX: 60
         },
         y: [{
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(0) + "$";
             }
             return y;
             
           }
         }, {
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(2) + "$";
             }
             return y;
             
           }},
           {
             formatter: function (y) {
               if(typeof y !== "undefined") {
                 return  y.toFixed(4) + "%";
               }
               return y;
               
             }
         }]
       },
       legend: {
         horizontalAlign: 'left',
         offsetX: 40
       }
       }
 
      
     
     
       });




      const [lineaMargen, setlineaMargen] = useState({
     
        options: {
          series: [
          ],
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#77B6EA', '#545454'],
          dataLabels: {
            enabled: false, 
            align: 'left',
           
          offsetX: 7,
          offsetY: 0,    
            formatter: function(val, opt) {
              return val.toFixed(0) + "%";
          },
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Margenes',
            align: 'left'
          },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            align: 'left',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 1
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  return  y.toFixed(0) + "%";
                }
                return y;
                
              }
            }
          },
          xaxis: {
            categories: ['2021', '2022', '2023','2024'],
            title: {
              text: 'Year'
            }
          },
          yaxis: {
            title: {
              text: '%'
            },
            gridLines: {
              drawBorder: false,
          },
            min: 0,
            max: 300,
            //forceNiceScale: true,
          },
      
          legend: {
            enabled:true,
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }
          
          }
        
     
      
      
        });

        



  const [ejemploChart3, setejemploChart3] = useState({
    name: "",
    color: "#2271b3",
    data: [],
  })
  
  const [ejemploOptionChart3, setEjemploOptionColumnChart3] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  


  const [ejemploChartMargen, setejemploChartMargen] = useState({
    name: "",
    color: "#87CEEB",
    data: [],
  })
  
  const [ejemploOptionChartMargen, setEjemploOptionColumnChartMargen] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
      
        dataLabels: {
          position: 'top', // top, center, bottom
        },
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  


  const [accumTotal, setAccumTotal] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [accumTotalChart, setAccumTotalChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });

  const [optionChart1indice, setOptionChart1indice] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [optionChart1, setOptionChart1] = useState({
    chart: {
      type: "area",
      foreColor: "#20603d",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });
  const [optionChart2, setOptionChart2] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [ejemploOptionTortaChart1, setEjemploTortaOptionChart] = useState({
        
    series: [],
    options: {
      chart: {
        width: 150,
        type: 'donut',
        color:'#252850'
      },
      colors: ['#252850', '#87CEEB'],
      tooltip: {
        fillSeriesColor: true,
      },
      total: {
        show: true
    },
      labels: ['utilidades','perdidas'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'center'
          }
        }
      }]
    }
  })

const [ejemploRadial, setEjemploRadial] = useState({
        
  series: [90],
  options: {
  chart: {
    height: 350,
    type: 'radialBar',
    
},
title: {
  text: 'Crecimiento',
  //offsetX: 110
},
labels: ['2024'],
plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
          },
          total:{
            show: true,
          },
          value:{
            show: true,
          },
          dataLabels:{
            value:{
              show: true,
            },
          }
        },
      },
    }
  })




  const [ejemploRadial2, setEjemploRadial2] = useState({
        
    series: [90],
    options: {
    chart: {
      height: 350,
      type: 'radialBar',
  },
  title: {
    text: 'crecimiento',
    //offsetX: 110
  },
  labels: ['2024'],
  plotOptions: {
          radialBar: {
            hollow: {
              size: "70%",
            },
            total:{
              show: true,
            },
            value:{
              show: true,
            },
            dataLabels:{
              value:{
                show: true,
              },
            }
          },
        },
      }
    })







  const [optionChart, setOptionChart] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [optionColumnChartPrueba, setOptionColumnChartPrueba] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [chartRoaRoe, setChartRoaRoe] = useState({})

  const [chartCrecimiento, setChartCrecimiento] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      stroke: {
        width: [0, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                horizontal: false
              }
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos'
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
        formatter: function(val, opt) {
          return val+"%"
      },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "%";
            }
            return y;
            
          }
        }]
        
      },
      labels: [],
      yaxis: [{
        title: {
          text: 'Ventas',
        },
      
      }, {
        opposite: true,
        title: {
          text: 'Crecimiento'
        }
      }]
      }
    })




    const [chartGastosAdm, setChartGastosAdm] = useState({
      series: [],
      options: {
        chart: {
          height: 350,
          stacked: true,
          color:'#e7e7e7',
          type: 'line',
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [3],
        },
        stroke: {
          width: [1, 1, 1,2]
        },
        title: {
          text: 'Gastos adm',
          align: 'left',
          offsetX: 110
        },
        xaxis: {
          categories: [2009, 2010, 2011, 2012],
        },
        yaxis: [
          {
            seriesName: 'Income',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB',
              }
            },
            title: {
              text: "Income (thousand crores)",
              style: {
                color: '#008FFB',
              }
            },
            tooltip: {
              enabled: true
            },
            min: 0,
            max: 3000000000

          },
          {
            seriesName: 'Cashflow',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                colors: '#00E396',
              }
            },
            title: {
              text: "Operating Cashflow (thousand crores)",
              style: {
                color: '#00E396',
              }
            },
          },
          {
            seriesName: 'Revenue',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#FEB019'
            },
            labels: {
              style: {
                colors: '#FEB019',
              },
            },
            title: {
              text: "Revenue (thousand crores)",
              style: {
                color: '#FEB019',
              }
            }
          },
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          },
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
        }
      })



  const [dailyReturnC, setDailyReturnC] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnWinnersTotal, setReturnOnWinnersTotal] = useState(0);
  const [returnOnWinnersChart, setReturnOnWinnersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnLosersTotal, setReturnOnLosersTotal] = useState(0);
  const [returnOnLosersChart, setReturnOnLosersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnLongTotal, setReturnLongTotal] = useState(0);
  const [returnLongChart, setReturnLongChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnShortTotal, setReturnShortTotal] = useState(0);
  const [returnShortChart, setReturnShortChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestProfitT, setBiggestProfitT] = useState(0);
  const [biggestLoseT, setBiggestLoseT] = useState(0);
  const [winLoseRatio, setWinLoseRatio] = useState(1);
  const [closedTradesTotal, setClosedTradesTotal] = useState(0);
  const [closedTradesChart, setClosedTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openTradesTotal, setOpenTradesTotal] = useState(0);
  const [openTradesChart, setOpenTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [allTradesTotal, setAllTradesTotal] = useState(0);
  const [allTradesChart, setAllTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [avgNumTrades, setAvgNumTrades] = useState(0);
  const [totalWin, setTotalWin] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalWinChart, setTotalWinChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalLossChart, setTotalLossChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [beTotal, setBeTotal] = useState(0);
  const [totalBeChart, setTotalBeChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openPercent, setOpenPercent] = useState(0);
  const [accumReturnPercentTotal, setAccumReturnPercentTotal] = useState(0);
  const [accumReturnPercentSeries, setAccumReturnPercentSeries] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestPercentProfit, setBiggestPercentProfit] = useState(0);
  const [biggestPercentLose, setBiggestPercentLose] = useState(0);
  const [percentProfitsChart, setPercentProfitsChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [percentLosesChart, setPercentLosesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalReturnNet, setTotalReturnNet] = useState(0);
  
  const [totalReturnNetChart, setTotalReturnNetChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });



  useEffect(() => {
   
    (async () => {
     
      setEstadoData(true);
      setIsLoading(true);
      dispatch(setReportsLoading());
      //7loading=true
      //alert("la var es "+loading)
      await axios
        .post("/api/get_reports_odoo", {
          userId,
          filters
        }
       
      
      
      )
        .then(
          (res) => {

          const {
        
            insights,
            clasificacion_ABC,
            moneda_company
          } = res.data;
        setCurrency(moneda_company);
        setisights(insights)
        setIsLoading(false)

        const mapABC = { A: 3, B: 2, C: 1 };
        const categories = Object.keys(clasificacion_ABC);
        //const seriesData = Object.values(clasificacion_ABC).map(v => mapABC[v]);
        const seriesData = Object.entries(clasificacion_ABC).map(([name, info]) => ({
          x: name,
          y: info.ventas,
          categoria: info.categoria
        }));
        const colors = seriesData.map((p) => {
          if (p.categoria === "A") return "#00C853";   // Verde
          if (p.categoria === "B") return "#FFC107";   // Amarillo
          return "#F44336";                            // Rojo
        });
        
         setoptions1({
            ...options1, 
            chart: {
              type: 'bar'
            },
            colors:colors,
            plotOptions: {
              bar: {
                horizontal: true,
                distributed: true
              }
            },
            xaxis: {
              categories: categories,
              labels: {
                formatter: (val) => {
                  if (val === 3) return 'i';
                  if (val === 2) return 'i';
                  if (val === 1) return 'i';
                  return val;
                }
              }
            },
            tooltip: {
                y: {
      formatter: function (val, { dataPointIndex, w }) {
        val=toMoney(val)
        const item = w.config.series[0].data[dataPointIndex];
        return `${val} | Categoría: ${item.categoria}`;
      }}
            }
          });

        
          
                  setseries1([
          {
            name: 'Ventas',
            data: seriesData
          }
        ]);
          
      
         })
        .catch((err) => console.log("esto es "+err));
    //  setIsLoading(false);
    })();
  }, [selected, filters]);


if(isLoading){

return  ( <Stack width="100%" justifyContent="center" alignItems="center">
     
<Spinner/>
<Typography variant="h5" sx={{ color: '#0094b6' }}>Please wait</Typography>
</Stack>)

  }
else{

  return (

    <Stack>
      {/*
      {isLoading? (
        <Stack width="100%" justifyContent="center" alignItems="center">
          <Spinner /> */}

{Object.keys(Insights).length==0? (
    <Fade in={true} timeout={3600}>
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack py={10} alignItems="center" color="text.disabled">
        <TextSnippetIcon sx={{ fontSize: 120 }} />
        <Typography variant="h4">No data to display in Odo</Typography>
      </Stack>
    </Paper>
  </Fade>
    ):(
      
      <Stack spacing={2}>
     <div
  style={{
    display: "flex",
    gap: "16px",
    flexWrap: "wrap"
  }}>

 {
  decisiones
 .map((d) => {
  const lista = Insights[d.tipo];
  if (!lista || lista.length === 0) return null;

 
  return(
  <div key={d.tipo} style={{flex: "1 1 30%",borderLeft: `6px solid ${d.color}`,padding: 16,marginBottom: 16,animation: "fadeUp 0.5s ease",boxSizing: "border-box"}}> 
      <h3>{d.titulo}</h3>
      <p>{d.descripcion}</p>

        <ul>
          {lista.map((item, idx) => {
            let texto = "";

            if (d.tipo === "stock_risk") {
              texto = `${item.dias_restantes.toFixed(1)} días restantes`;
            } else if (d.tipo === "overstock") {
              texto = `${item.dias_inventario?.toFixed(1)} días en inventario`;
            } 

            if(item.categoria==='A'){
              texto ="Este producto lo vendes mucho"
            }else if(item.categoria==='C'){
              texto ="Este producto no lo vendes casi"
            }else if(item.categoria==='B'){
              texto ="Este producto lo vendes moderadamente"
            }

            return (
              <li key={idx}>
                {item.product} — {item.stock} {item.medida}&nbsp;&nbsp;&nbsp;{texto}&nbsp;&nbsp;&nbsp;{item.categoria}
              </li>
            );
          })}
        </ul>
    </div>
  );
})}
 
 </div>
 <div style={{ textAlign: "center", marginBottom: "20px" }}>
  <h2 style={{ marginBottom: "10px" }}>
    📊 Productos según su nivel de rotación en ventas
  </h2>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "30px",
      fontWeight: "bold",
      fontSize: "15px"
    }}
  >
    <span style={{ color: "#00C853" }}>🟢 Alta rotación</span>
    <span style={{ color: "#FFC107" }}>🟡 Rotación media</span>
    <span style={{ color: "#F44336" }}>🔴 Baja rotación</span>
  </div>
  <p
  style={{
    textAlign: "center",
    color: "#666",
    marginTop: "10px"
  }}
>
  🟢 Productos que generan la mayor parte de las ventas ·
  🟡 Productos con ventas moderadas ·
  🔴 Productos con baja participación en las ventas
</p>
</div>
 <Chart options={options1} series={series1} type="bar" height={500} />
</Stack>

      )
      

  }

    </Stack>

  )}}